const PROFILE_KEY = "ore-user-profile";
const NAV_KEY = "ore-nav";
const STORAGE = 'local';
const AUTH_TOKEN_KEY = "ore-auth-key";

export default {
    clearBrowserData(vcookies){
        this.clearCookies(vcookies);
        this.clearBrowerStorage();
    },
    clearBrowerStorage(){
        if (STORAGE=='local') {
            this.clearLocalStorage();
        }
        else {
            this.clearSessionStorage();
        }
    },
    clearCookies(vcookies){
        vcookies.remove(PROFILE_KEY);
        vcookies.remove(NAV_KEY);
        vcookies.remove(AUTH_TOKEN_KEY);
    },
    clearLocalStorage(){
        localStorage.removeItem(PROFILE_KEY);
        localStorage.removeItem(NAV_KEY);
        localStorage.removeItem(AUTH_TOKEN_KEY);
    },
    clearSessionStorage(){
        sessionStorage.removeItem(PROFILE_KEY);
        sessionStorage.removeItem(NAV_KEY);
        sessionStorage.removeItem(AUTH_TOKEN_KEY);
    },
    getBrowserData(vcookies,dataName,storeData){
        return this.getData(vcookies,dataName,storeData);
    },
    getData(vcookies,dataName,storeData){
        var returnData = storeData;
        if (!returnData) {
            returnData = vcookies.get(dataName);
        }
        try {
            if (!returnData) {
                returnData = JSON.parse(localStorage.getItem(dataName));
            }
        }
        catch(dErr){}
        return returnData;
    },
    setBrowserData(){
        // sets both profile and active nav
    },
    setProfile(vcookies,data){
        var processedData = JSON.stringify(data);
        this.setData(vcookies,PROFILE_KEY,processedData);
    },
    setToken(vcookies,data) {
        this.setData(vcookies,AUTH_TOKEN_KEY,data);
    },
    setActiveNav(vcookies,data){
        var processedData = JSON.stringify(data);
        this.setData(vcookies,NAV_KEY,processedData);
    },
    setData(vcookies,dataName,data){
        vcookies.set(dataName,data);
        this.setStorageData(dataName,data);
    },
    setStorageData(dataName,data) {
        if (STORAGE=='local'){
            localStorage.setItem(dataName,data);
        }
        else {
            sessionStorage.setItem(dataName,data);
        }
     }
}


// WEBPACK FOOTER //
// ./src/utilities/BrowserDataUtil.js